var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-8"},[_c('b-form-checkbox',{attrs:{"id":_vm.code,"name":_vm.code,"required":_vm.required},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }